import React, {useState} from 'react';
import {useProviderProfile} from "../../ProviderProfileProvider";
import './AdminHeader.css';
import {AdminBusinessSearchRequest, AdminBusinessSearchResponse, IAdminBusinessSearchRequest} from "../../provider_api";
import {useRpcSender} from "../../util/RpcSender";
import {RpcState} from "../../util/RpcState";
import {useImpersonation} from "./AdminUtils";
import {DropdownMenu} from "../../components/DropdownMenu/DropdownMenu";
import {useBusinessLogins} from "../../util/RpcHooks/BusinessLoginsLoader";
import IBusinessSearchResult = AdminBusinessSearchResponse.IBusinessSearchResult;
import {useKensuAuth} from "../../util/authwrapper/AuthWrapper";
import {isProduction} from "../../util/HostUtils";

export const AdminHeader = () => {

  const rpcSender = useRpcSender();

  const {user} = useKensuAuth();

  const {
    authenticatedUserRoles,
    business,
    businessProfile,
    provider
  } = useProviderProfile();


  // The query is timestamped so out-of-order responses get handled correctly.
  const [query, setQuery] = useState('');

  const [queryResults, setQueryResults] = useState<IBusinessSearchResult[]>([]);

  const [rpcState, setRpcState] = useState<RpcState>({state: 'none'});

  const [focused, setFocused] = useState(false);

  const impersonation = useImpersonation();

  const {logins} = useBusinessLogins({forAdminHeader: true});

  const doQuery = (query: string) => {
    if (!query || query.trim().length == 0) {
      setQueryResults([]);
      setRpcState({state: 'none'});
      return;
    }

    sendRpc(query);
  }

  const sendRpc = (query: string) => {
    setRpcState({state: 'pending'});
    rpcSender.send('admin_business_search', AdminBusinessSearchRequest.encode(new AdminBusinessSearchRequest({
      query: query
    })).finish())
        .then(value => {
          const response = AdminBusinessSearchResponse.decode(value);

          if (response.okay) {
            setRpcState({state: 'success'});
            setQueryResults(response.searchResult);
          }
        })
        .catch(reason => {
          alert('rpc error ' + reason)
          setRpcState({state: 'error', message: reason})
        })
  }

  const renderSearchResult = (result: IBusinessSearchResult) => {
    return (
        <div className={'BusinessSearchResult'}
             key={result.business?.businessId || 0}
             onClick={() => {
               impersonation.setImpersonatedBusiness(result.business?.businessId)
             }
             }>
          <><b>{result.profile?.proto?.businessName || 'unnamed'}</b> ({result.business?.businessId})</>
        </div>)
  };

  if (authenticatedUserRoles.indexOf('admin') < 0) {
    return <></>
  }

  return <div className={isProduction() ? 'AdminHeader AdminHeaderProd' : 'AdminHeader'}>

    <div>[admin]</div>

    <div style={{flex: 1}}>
      <div className={'VerticalFlex'}>
        <div>
          {/* The admin user may or may not have a business entirely */}
          Business:&nbsp;
          {!businessProfile?.proto && <b>None</b>}
          {!!businessProfile?.proto && <>
            <b>{businessProfile.proto.businessName || 'unnamed'}</b> ({business?.businessId})</>}
        </div>
      </div>
      <div className={'HorizontalFlex'}>
        {/* The admin user may or may not have a business entirely */}
        Impersonating:&nbsp;
        <b>{provider?.lastLoginEmail}&nbsp;</b>
        ({provider?.loginId == user?.sub ? 'You' : <span style={{color: 'var(--red)'}}>NOT&nbsp;YOU</span>})
        <DropdownMenu buttonContent={<span style={{textDecoration: 'underline'}}>(switch)</span>}
                      links={logins?.map(login => {
                        return {
                          text: login.lastLoginEmail as string,
                          onClick: () => {
                            impersonation.setImpersonatedProvider(login)
                          }
                        }
                      }) ?? []
                      }/>
      </div>
    </div>

    <div className={'VerticalFlex'}>
      <div className={'HorizontalFlex'}>
        find a business:&nbsp;
        <input type={'text'}
               name={'businessSearch'}
               value={query}
               onFocus={() => setFocused(true)}
               onBlur={() => {
                 // Keeps the blur from happening before a click on an item.
                 setTimeout(() => setFocused(false), 150);
               }}
               onChange={e => {
                 setQuery(e.target.value)
                 doQuery(e.target.value);
               }}/>
      </div>

      {/* this div is an anchor for the relative'y positioned overlay*/}
      <div style={{position: 'relative'}}>
        {queryResults && focused && <div className={'BusinessSearchResultOverlay'}>
          {queryResults.map(renderSearchResult)}
        </div>}

        {rpcState.state == 'pending' && !queryResults.length && focused &&
            <div className={'BusinessSearchResultOverlay'}>
              <div className={'BusinessSearchResult'}>Searching...</div>
            </div>}

        {rpcState.state == 'success' && !queryResults.length && focused &&
            <div className={'BusinessSearchResultOverlay'}>
              <div className={'BusinessSearchResult'}>No businesses found</div>
            </div>}
      </div>

    </div>

  </div>
}